import dataSource from './questionnare.json';

export const questionList = dataSource.questions;